<template>
<nav class="navbar navbar-expand-lg navbar-light" style="background-color: var(--theme-color);padding:0;padding-left:5px;padding-right:5px">
  <!-- <a class="navbar-brand navBarLink"><img src="@/assets/icon_50.png" class="iconDetails"> {{ AppTitle }} </a> -->
  <router-link class="navbar-brand navBarLink" to="/"> <img src="@/assets/unk_logo_50.png" class="iconDetails" style="margin-top:3px;margin-bottom:3px;font-size:16px;"> {{ AppTitle }}   </router-link>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
   <div class="collapse navbar-collapse" id="navbarNavDropdown">

        <li class="nav-item dropdown list-unstyled pt-1" v-if="isUserLoggedIn">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="anchor" size="sm" class='navBarIcon'/>
            Seafarers
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="nav-link nav-link-dropdown" to="/seafarer" v-if="isUserLoggedIn && isUserAdminOrOperator"><font-awesome-icon icon="plus" size="sm" class='navBarIcon'/>New Seafarer</router-link>

                <div class="dropdown-divider" v-if="isUserLoggedIn && isUserAdminOrOperator"></div>

                <router-link class="nav-link nav-link-dropdown" to="/seafarers"><font-awesome-icon icon="eye" size="sm" class='navBarIcon'/>View Seafarers</router-link>
               
                <div class="dropdown-divider"></div>

                <router-link class="nav-link nav-link-dropdown" to="/online-cvs" v-if="isUserLoggedIn && isUserAdminOrOperator"><font-awesome-icon icon="eye" size="sm" class='navBarIcon'/>Online CVs</router-link>
                
                <div class="dropdown-divider" v-if="isUserLoggedIn && isUserAdminOrOperator"></div>

                <router-link class="nav-link nav-link-dropdown" to="/online-cv-seafarer"  v-if="isUserLoggedIn && isUserAdminOrOperator"><font-awesome-icon icon="address-card" size="sm" class='navBarIcon'/>GoTo Online CV</router-link>


            </div>
        </li>

        <li class="nav-item dropdown list-unstyled pt-1" v-if="isUserLoggedIn && isUserAdminOrOperator">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="ship" size="sm" class='navBarIcon'/>
            Vessels
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="nav-link nav-link-dropdown" to="/vessel"><font-awesome-icon icon="plus" size="sm" class='navBarIcon'/>New Vessel</router-link>

                <div class="dropdown-divider"></div>

                <router-link class="nav-link nav-link-dropdown" to="/vessels"><font-awesome-icon icon="eye" size="sm" class='navBarIcon'/>View Vessels</router-link>
               

            </div>
        </li>

        <li class="nav-item dropdown list-unstyled pt-1" v-if="isUserLoggedIn && isUserAdminOrOperator">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="users" size="sm" class='navBarIcon'/>
            Clients
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="nav-link nav-link-dropdown" to="/client"><font-awesome-icon icon="plus" size="sm" class='navBarIcon'/>New Client</router-link>

                <div class="dropdown-divider"></div>

                <router-link class="nav-link nav-link-dropdown" to="/clients"><font-awesome-icon icon="eye" size="sm" class='navBarIcon'/>View Clients</router-link>
               

            </div>
        </li>

        <li class="nav-item dropdown list-unstyled pt-1" v-if="isUserLoggedIn && isUserAdminOrOperator">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="tag" size="sm" class='navBarIcon'/>
            CBAs
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="nav-link nav-link-dropdown" to="/cba"><font-awesome-icon icon="plus" size="sm" class='navBarIcon'/>New CBA</router-link>

                <div class="dropdown-divider"></div>

                <router-link class="nav-link nav-link-dropdown" to="/cbas"><font-awesome-icon icon="eye" size="sm" class='navBarIcon'/>View CBAs</router-link>
               

            </div>
        </li>

        <li class="nav-item dropdown list-unstyled pt-1" v-if="isUserLoggedIn && isUserAdmin">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="users" size="sm" class='navBarIcon'/>
            Users
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="nav-link nav-link-dropdown" to="/user"><font-awesome-icon icon="plus" size="sm" class='navBarIcon'/>New User</router-link>

                <div class="dropdown-divider"></div>

                <router-link class="nav-link nav-link-dropdown" to="/users"><font-awesome-icon icon="eye" size="sm" class='navBarIcon'/>View Users</router-link>
               

            </div>
        </li>

        <li class="nav-item dropdown list-unstyled pt-1" v-if="isUserLoggedIn && isUserAdminOrOperator">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="cog" size="sm" class='navBarIcon'/>
            Settings
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link class="nav-link nav-link-dropdown" to="/settings" v-if="isUserAdmin"><font-awesome-icon icon="cog" size="sm" class='navBarIcon'/>Settings</router-link>
                <div class="dropdown-divider" v-if="isUserAdmin"></div>
                <router-link class="nav-link nav-link-dropdown" to="/dropdowns"><font-awesome-icon icon="check-double" size="sm" class='navBarIcon'/>Dropdowns</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="nav-link nav-link-dropdown" to="/about"><font-awesome-icon icon="address-card" size="sm" class='navBarIcon'/>About</router-link>
            

            </div>
        </li>

        <li class="nav-item dropdown list-unstyled pt-1" style="padding-right:200px" v-if="isUserLoggedIn && isUserAdminOrOperator">
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="file" size="sm" class='navBarIcon'/>
            Reports
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown" >
                <router-link v-if="isUserLoggedIn && isUserAdmin" class="nav-link nav-link-dropdown" to="/report-contact" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Seafarer Contact Details</router-link>
                <router-link v-if="isUserLoggedIn && isUserAdmin" class="nav-link nav-link-dropdown" to="/report-email" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Seafarer Email Details</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-status-list" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Seafarer Status List</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-articles-as-of-today" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Articles as of Today</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-articles" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Articles opened Within a Period</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-mlcs" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Vessel MLC</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-sign-on-list" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Signed-on List Within a Period</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-sign-off-list" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Signed-off List Within a Period</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-sign-off-pending" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Sign-off Pending List</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-current-onboard" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Current On-Board List</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-off-signers" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Off-Signers List</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-travel" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Export to Travel</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-socialsecurity-contrib-seafarer" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Social Security Contribution - Seafarer</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-socialsecurity-contrib-vessel" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Social Security Contribution - Vessel</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-socialsecurity-contrib-client" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Social Security Contribution - Client</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-expiring-docs" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Expiring Documents in 90 Days</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-expiring-docs-period" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Expiring Documents</router-link>
                <router-link v-if="isUserLoggedIn"                class="nav-link nav-link-dropdown" to="/report-expired-docs" style="padding-right:5px"><font-awesome-icon icon="file" size="sm" class='navBarIcon'/>Expired Documents</router-link>


            </div>
        </li>

        <!-- <li class="nav-item dropdown list-unstyled pt-1">
            <router-link class="nav-link navBarLink" to="/login"><span style="color:red;font-weight:bold">TRIAL MODE</span></router-link>
        </li> -->

    <!-- Right aligned items -->
    <ul class="navbar-nav ml-auto">

        <!-- Notifications Icon -->
        <!-- <div>
            <b-button v-b-toggle.sidebar-right pill size="sm" variant="warning"><font-awesome-icon icon="bell" size="md" class='p-0 m-1 iIcon' style="color:red"/></b-button>
            <b-sidebar id="sidebar-right" right shadow>
            <div class="px-3 py-2">
                <h3 class="ititle pb-3" style="font-size:16px;color:var(--theme-color);font-weight:bold">Notifications</h3>
                <p>
                Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis
                in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                </p>
            </div>
            </b-sidebar>
        </div> -->

        
        

        

        <li class="nav-item pt-3" v-if="!isUserLoggedIn">
            <router-link class="nav-link navBarLink" to="/login"> Login</router-link>
        </li>

        <li class="nav-item dropdown pt-1" v-else>
            <a class="nav-link dropdown-toggle navBarLink" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="user" size="sm" class='navBarIcon'/>
            Profile
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                
                <router-link class="nav-link nav-link-dropdown" to="/profile"><font-awesome-icon icon="user" size="sm" class='navBarIcon'/>View Profile</router-link>
                <router-link class="nav-link nav-link-dropdown" to="/logout"><font-awesome-icon icon="user" size="sm" class='navBarIcon'/>Sign-out</router-link>


            </div>
        </li>        

    </ul>
  </div>

  <v-dialog v-model="showLoginDialog" persistent max-width="500px" >
   
    <v-card>
        <v-card-title class="justify-center">You must login first!</v-card-title>
        <v-divider></v-divider>   

        <v-card-text >
            <h6>If you do not have an account, please create one first.</h6>
        </v-card-text>
        
        <v-divider></v-divider>
        
        <v-card-actions class="justify-center">
            <v-btn color="blue darken-1" text @click="login()">Login</v-btn>  
            <v-btn color="blue darken-1" text @click="createAccount()">Create Account</v-btn>  
            <v-btn color="blue darken-1" text @click="showLoginDialog=false">Close</v-btn>   
        </v-card-actions>
    </v-card>

    </v-dialog>

    <v-dialog v-model="showSignOffPendingSeafarerListFlag" persistent max-width="600px" >
   
        <v-card>
            <v-card-title class="justify-center">Welcome!</v-card-title>
            <v-divider></v-divider>   

            <v-card-text >
                
                <v-data-table :headers="signOffPendingSeafarerListHeaders" :items="signOffPendingSeafarerList" sort-by="createdAt" class="elevation-1" >
                    <template v-slot:top>
                        <v-toolbar flat >
                            <h6>Sign-off pending Seafarers for the next 30 Days</h6>                                   
                        </v-toolbar>
                    </template>

                    
                </v-data-table>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center">
                <v-btn color="blue darken-1" text @click="showSignOffPendingSeafarerListFlag=false">Close</v-btn>   
            </v-card-actions>
        </v-card>

   </v-dialog>
</nav>



</template>

<script>
import {AppTitle} from '@/Globals';
import {signOffPendingSeafarerList} from '@/Globals';

export default {
  name: "KNavBar",
  data() {
      return {
          AppTitle,
          isMobileDisplay :false,
          showLoginDialog:false,
          showSignOffPendingSeafarerListFlag : false,
          signOffPendingSeafarerList,
          signOffPendingSeafarerListHeaders: [
                { text: 'Name', align: 'start', sortable: true, value: 'name',},  
                { text: 'Approx Sign-Off Date', align: 'start', sortable: true, value: 'approxSignOffDate',},  
                
            ],
      }
  },
  computed:{
      isUserLoggedIn(){
          return this.$store.state.user? true:false;
      },
      isUserAdmin(){
          if(this.$store.state.user != undefined && this.$store.state.user != null){
              if(this.$store.state.user.role != undefined && this.$store.state.user.role == 'Admin'){
                  return true;
              }
          }
          return false;
      },
      isUserAdminOrOperator(){
          if(this.$store.state.user != undefined && this.$store.state.user != null){
              if(this.$store.state.user.role != undefined && (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Operator')){
                  return true;
              }
          }
          return false;
      },
      currentRouteName() {
        return this.$route.name;
      },
        showSignOffPendingSeafarerListGetter() {
            return  this.$store.state.showSignOffPendingSeafarerList;   
        }
  },
  methods:{
      onResize() {
        if (window.innerWidth > 768) {
        this.isMobileDisplay = false;
        } else {
        this.isMobileDisplay = true;
        }
    },
    login(){
        if(this.currentRouteName != "Login")
            this.$router.push("/login");

        this.showLoginDialog = false;
    },
    createAccount(){
        if(this.currentRouteName != "Register")
            this.$router.push("/register");

        this.showLoginDialog = false;
    },
    logout(){

    },
    

  },
    watch: {
        showSignOffPendingSeafarerListGetter : function() {
            this.showSignOffPendingSeafarerListFlag =  this.$store.state.showSignOffPendingSeafarerList;
        },  
    },
  created() {
      if (window.innerWidth > 768) {
      this.isMobileDisplay = false;
    } else {
      this.isMobileDisplay = true;
    }

  window.addEventListener('resize', this.onResize);
    },

    beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    },
};
</script>

<style>
#app .iconDetails {
height:3vh;
width:auto; 
border-radius: 1.5vh;
margin: 0px;
margin-top: 0px;
padding-top: 0;
padding-bottom: 0;
}


a{
   font-size: 14px; 
}

#app .navBarLink{
    color: white;
    padding-top: 0;
}

#app .navBarIcon{
    color: white;
    padding: 1px;
    margin-right: 5px;
}

#app .nav-link-dropdown{
    padding-top: 2px;
    padding-bottom: 2px;
    background-color: var(--theme-color);
    color: white;
    padding-right: 0px;
    margin-right: 0px ;
}
#app .dropdown-divider{

    background-color: var(--theme-color);
    color: white;
    padding: 0px;
    margin: 0px ;
}

#app .dropdown-menu{
    margin-right:0px;
    padding-right:0px;
    padding-top:0px;
    padding-bottom:0px;
}

/* Responsive navigation menu - display links on top of each other instead of next to each other (for mobile devices) */
@media screen and (max-width: 600px) {
  
}
</style>
